export default __webpack_public_path__ + "static/media/realtimerecords.0a8c0d24.png";